export enum UsersActionTypes {
    GET_USER_WEEKLY_NOTIFICATION_STATUS_REQUEST = '@@users/GET_USER_WEEKLY_NOTIFICATION_STATUS_REQUEST',
    UPDATE_USER_WEEKLY_NOTIFICATION_REQUEST = '@@users/UPDATE_USER_WEEKLY_NOTIFICATION_REQUEST',
}

export interface UsersState {
    readonly loading: boolean;
}
